<div class="display-flex flex-align-center">
  <app-comparative-search-menu></app-comparative-search-menu>
  <div class="ca-title-section" *ngIf="headerTitle">{{ headerTitle }}</div>
</div>
